// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResult__results-delimiter-c00aed {
  color: var(--base-70);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body);
  padding: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SearchResult/SearchResult.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,wBAAA;EACA,wCAAA;EACA,aAAA;AACF","sourcesContent":[".results-delimiter {\n  color: var(--base-70);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body);\n  padding: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"results-delimiter": `SearchResult__results-delimiter-c00aed`,
	"resultsDelimiter": `SearchResult__results-delimiter-c00aed`
};
module.exports = ___CSS_LOADER_EXPORT___;
